// extracted by mini-css-extract-plugin
module.exports = {"nav":"HotkeyNav_nav__dXrYp","navItem":"HotkeyNav_navItem__yx7AJ","hotkey":"HotkeyNav_hotkey__RIRP6"};